<template>
    <div class="contArea tpd"
         style="text-align: center; width: 100%; font-size: 1.2rem;"
    >
      <div style="margin-bottom: 30px"><img :src="`${$store.state.dir}images/ico_complete.png`"/></div>

      <p style="line-height: 1.5;">{{solicitation['name']}} 고객님의 <span style="color:royalblue">BMW ServiceCare+</span> 약관 동의가 완료 되었습니다.</p>

      <p>다음 단계를 진행해주세요.</p>
    </div>
</template>
<script>
export default{
  props: {solicitation: Object},
}
</script>
